import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useSubscriptionsStore = defineStore('subscriptions', () => {
    const allSubscriptions = ref(null);

    const actions = {
        subscribeToPlan: (params) => axios.post('api/v1/subscribe', params),
        unsubscribeFromPlan: (params) => axios.post('api/v1/unsubscribe', params),
        resubscribeToPlan: (params) => axios.post('api/v1/resubscribe', params),
    };

    const reset = () => {
        allSubscriptions.value = null;
    };

    return { 
        allSubscriptions,
        ...actions,
        reset
    };
});
